import { LanguageMap } from "./i18n"
import { onlineRus } from "./online"

export const rus: LanguageMap = {
    ...onlineRus,
    "game.localMode": "На одном устройстве",
    yacht: "Яхта",
    indigo: "Индиго",
    systemTheme: "Из системы",

    "button.startNewGame": "Начать новую игру",
    "button.restartGame": "Начать заново",
    "button.startGame": "Начать игру",
    "button.cancel": "Отмена",
    "button.addPlayer": "Добавить игрока",
    "button.removePlayer": "Удалить игрока",
    "button.restart": "Начать заново",
    "button.rotate": "Повернуть",
    "button.light": "Светлая",
    "button.dark": "Темная",
    "button.system": "Как в системе",
    "button.apply": "Применить",
    "button.viewBoard": "Посмотреть игру",
    "button.readRules": "Читать правила",
    "button.close": "Закрыть",
    "button.menu": "Меню",

    currentGameWillBeLost: "Текущая игра будет утеряна.",
    "result.text.h1": "Игра окончена!",
    winner: "Победитель",
    winners: "Общая победа",
    "game.stageOne": "Добавьте до четырёх игроков для локальной партии на одном устройстве.",
    "game.controls": "Управление ходом",
    "game.turn": "Ход",
    "game.moving": "Камни движутся",
    "game.collecting": "Игроки получают камни",
    "game.scoring": "Обновляется счёт",
    "game.tilesLeft": "Плиток в запасе",
    "game.currentTile": "Текущая плитка",
    "game.selectHint": "Нажмите на свободную клетку, поверните плитку и нажмите «Поставить».",
    "game.finishedHint": "Партия завершена. Можно рассмотреть поле или открыть результаты.",
    "game.wait": "Дождитесь завершения движения. Результат хода уже сохранён.",
    "game.gateBlocked": "Нельзя соединять дорожкой два выхода ворот. Поверните плитку или выберите другую клетку.",
    "game.invalidState": "Не удалось рассчитать ход. Состояние партии не изменено. Попробуйте другую клетку или начните новую игру.",
    "game.saveFailed": "Браузер не разрешил сохранить партию. Не закрывайте страницу: после перезагрузки прогресс может потеряться.",
    "game.rotateLeft": "Влево",
    "game.rotateRight": "Вправо",
    "game.place": "Поставить",
    "game.results": "Результаты",
    "player.p-1": "Фиолетовый",
    "player.p-2": "Бирюзовый",
    "player.p-3": "Коралловый",
    "player.p-4": "Белый",
    "player.name": "Имя",

}
